import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "card-header border-0 pt-6",
  style: {"position":"sticky","top":"45px","background-color":"white","z-index":"1"}
}
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_9 = { style: {"width":"100%","margin-left":"5px"} }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table table-striped gy-5 gs-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Platform"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Tarih"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Yorum"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Puan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Cevapla")
  ])
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Restoran Cevabı:", -1)
const _hoisted_18 = { class: "rating" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTNewTargetModal = _resolveComponent("KTNewTargetModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid w-250px ps-14",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
            placeholder: "Yorum Filtrele"
          }, null, 512), [
            [_vModelText, _ctx.filterText]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterMode = ''))
          }, " Tüm Yorumlar "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterMode = 'OnlyPoints'))
          }, " Sadece Puanlar "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterMode = 'OnlyComments'))
          }, " Sadece Yorumlar ")
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.filteredComments?.length ?? 0) + " Yorum bulundu ", 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredComments, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", {
                class: _normalizeClass(item.Platform)
              }, _toDisplayString(item.Platform), 3),
              _createElementVNode("td", null, _toDisplayString(item.ReviewDateStr), 1),
              _createElementVNode("td", null, [
                (item.Comment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.Comment), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, "(Sadece Puan Verilmiş)")),
                (item.RestaurantReply)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "text-info",
                      title: item.RestaurantReply.ReplyDate
                    }, [
                      _hoisted_16,
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(item.RestaurantReply.Reply), 1)
                    ], 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: _normalizeClass([[item.RestaurantRaiting >= i && 'checked'], "rating-label me-2"])
                    }, _hoisted_20, 2)
                  }), 64))
                ])
              ]),
              _createElementVNode("td", null, [
                (
                    item.Comment &&
                    item.CanBeReplied &&
                    item.RestaurantRaiting != 0
                  )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-bg-white btn-active-color-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_new_target",
                      id: "new-target-modal",
                      onClick: ($event: any) => {_ctx.Id = item.Id ; _ctx.IntegrationId = item.IntegrationId}
                    }, " Cevapla ", 8, _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createVNode(_component_KTNewTargetModal, {
            id: _ctx.Id,
            "integration-id": _ctx.IntegrationId
          }, null, 8, ["id", "integration-id"])
        ])
      ])
    ])
  ]))
}